import React from 'react';
import OrderDetailsPage from './containers/orders/OrderDetailsPage';
import AdminUserDetails from './containers/admin/usermanagement/user/UserDetails';
import AdminManageAcess from './containers/admin/usermanagement/ManageAccess';
import AdminGroupDetails from './containers/admin/usermanagement/group/GroupDetails';
import Dashboard from './containers/dashboard/Dashboard';
import Reports from './containers/report/Reports';
import AccountDetailsPage from './containers/accounts/AccountDetailsPage';
import OrderSearch from './containers/orders/OrderSearch';
import CustomerDetailsPage from './containers/customers/CustomerDetailsPage';
import PaylinkDetails from './containers/paylinks/PaylinkDetails';
import ManageStores from './containers/admin/stores/ManageStores';
import StoreDetails from './containers/admin/stores/StoreDetails';
import PaylinkList from './containers/paylinks/PaylinkSearch';
import { LogsSearch } from './components/molecules/Logs/LogsSearch';
import B2BManagement from './components/molecules/B2B/B2BManagement';
import GuidedSetupPage from './containers/GuidedSetup/GuidedSetupPage';

const routes = [
    {
        path: '/orders',
        component: <OrderSearch />,
        breadcrumb: 'Search',
    },
    { path: '/orders/:orderId', component: <OrderDetailsPage />, breadcrumb: 'Order' },

    { path: '/dashboard', component: <Dashboard />, breadcrumb: 'Dashboard' },

    { path: '/get-started', component: <GuidedSetupPage />, breadcrumb: 'Get started' },

    {
        path: '/accounts/:accountId',
        component: <AccountDetailsPage />,
        breadcrumb: 'Account',
    },
    {
        path: '/customers/by/orgId/:country/:orgId',
        component: <CustomerDetailsPage />,
        breadcrumb: 'Customer by Org Id',
    },
    { path: '/customers/:customerId', component: <CustomerDetailsPage />, breadcrumb: 'Customer' },
    {
        path: '/paylinks',
        component: <PaylinkList showNewPaylinkPopupOnLoad={false} />,
        breadcrumb: 'ListPaylinks',
    },
    {
        path: '/new-paylink',
        component: <PaylinkList showNewPaylinkPopupOnLoad={true} />,
        breadcrumb: 'ListPaylinks',
    },
    {
        path: '/paylinks/:privateId',
        component: <PaylinkDetails />,
        breadcrumb: 'Paylink',
    },
    { path: '/reports', component: <Reports />, breadcrumb: 'Reports' },
    {
        path: '/logs',
        component: <LogsSearch />,
        breadcrumb: 'Developer Logs',
    },
    {
        path: '/companies',
        component: <B2BManagement />,
        breadcrumb: 'Companies',
    },
    { path: '/admin/users/:userId', component: <AdminUserDetails /> },
    {
        path: '/admin/manage-access',
        component: <AdminManageAcess />,
        breadcrumb: 'Manage Access',
    },
    {
        path: '/admin/manage-organization',
        component: <AdminManageAcess />,
        breadcrumb: 'Manage Organization',
    },
    {
        path: '/admin/groups/:groupId',
        component: <AdminGroupDetails />,
    },
    {
        path: '/admin/manage-stores/:storeId',
        component: <StoreDetails />,
    },
    { path: '/admin/manage-stores', component: <ManageStores /> },
];

export default routes;
